import React, { ComponentType } from 'react'
import {
  SvgDynamicTag,
  SvgGoToMeeting,
  SvgLocation,
  SvgMeet,
  SvgMicrosoftTeams,
  SvgRingcentral,
  SvgTextLong,
  SvgWebex,
  SvgZoom,
  SvgZoomMonochromatic,
  SvgHopin,
  SvgGong,
} from '@chilipiper/icons/src/design-system/3rd-party-integrations'
import { SvgSmartphone } from '@chilipiper/icons/src/design-system'
import { Icon } from './Icon'

export type ThirdParties =
  | 'GoToMeeting'
  | 'Webex'
  | 'RingCentral'
  | 'Zoom'
  | 'ZoomMonochromatic'
  | 'ConferenceDetails'
  | 'Phone'
  | 'Location'
  | 'Custom'
  | 'Guest'
  | 'GoogleMeet'
  | 'MicrosoftTeams'
  | 'Hopin'
  | 'Gong'

type Props = Omit<React.ComponentProps<typeof Icon>, 'icon'> & {
  name: ThirdParties
}

const map: Record<ThirdParties, ComponentType> = {
  GoToMeeting: SvgGoToMeeting,
  Webex: SvgWebex,
  RingCentral: SvgRingcentral,
  Zoom: SvgZoom,
  ZoomMonochromatic: SvgZoomMonochromatic,
  ConferenceDetails: SvgTextLong,
  Phone: SvgSmartphone,
  Location: SvgLocation,
  Custom: SvgDynamicTag,
  Guest: SvgTextLong,
  MicrosoftTeams: SvgMicrosoftTeams,
  GoogleMeet: SvgMeet,
  Hopin: SvgHopin,
  Gong: SvgGong,
}

export const ThirdPartyIcon = ({ name, color = 'text/body-major', ...rest }: Props) => {
  return <Icon icon={map[name]} color={color} {...rest} />
}
